import { Users, Copy, Check } from 'lucide-react';
import { useState } from 'react';
import styles from './PatientsEmptyState.module.css';

interface PatientsEmptyStateProps {
  proCode: string | null;
}

export function PatientsEmptyState({ proCode }: PatientsEmptyStateProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!proCode) return;
    try {
      await navigator.clipboard.writeText(proCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // fallback: nothing for now
    }
  };

  return (
    <div className={styles.wrap}>
      <div className={styles.iconBox}>
        <Users size={28} strokeWidth={2} />
      </div>
      <h2 className={styles.title}>Nessun cliente ancora</h2>
      <p className={styles.sub}>
        Condividi il codice invito per agganciare il primo cliente.
      </p>

      {proCode && (
        <div className={styles.codeBox}>
          <div className={styles.codeLabel}>Codice invito</div>
          <div className={styles.codeValue}>
            <span className="tnum">{proCode}</span>
            <button
              className={styles.copyBtn}
              type="button"
              onClick={handleCopy}
              aria-label="Copia codice"
            >
              {copied ? (
                <Check size={14} strokeWidth={2.5} />
              ) : (
                <Copy size={14} strokeWidth={2.2} />
              )}
            </button>
          </div>
          <div className={styles.codeHint}>
            Il cliente lo inserisce in fase di registrazione.
          </div>
        </div>
      )}
    </div>
  );
}
